export default __webpack_public_path__ + "static/abode-logo-5779cd7c3dc6f3f0d7c7bd7c8b2716e3.png";